// extracted by mini-css-extract-plugin
export default {"sceneViewer":"shape_viewer_sceneViewer__ofe6W","overlay":"shape_viewer_overlay__5KHAA","overlayActive":"shape_viewer_overlayActive__xJewT","svg":"shape_viewer_svg__f+d55"};